<tour-step-template>
    <ng-template let-step="step">
        <mat-card
            class="tour-card"
            (click)="onClick($event)"
            [style.width]="step.stepDimensions?.width"
            [style.min-width]="step.stepDimensions?.minWidth"
            [style.max-width]="step.stepDimensions?.maxWidth"
            [style.height]="step.stepDimensions?.height"
            [style.min-height]="step.stepDimensions?.minHeight"
            [style.max-height]="step.stepDimensions?.maxHeight"
        >
            <mat-card-header>
                <div class="header-group">
                    <mat-card-title>
                        {{ step.title }}
                    </mat-card-title>
                    <button mat-icon-button (click)="tourEnd()" class="close">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </mat-card-header>

            <mat-card-content class="mat-body" [innerHTML]="step.content"></mat-card-content>

            <mat-card-actions [class.no-progress]="!step.showProgress">
                @if (!isDirectSearchTour) {
                <button mat-button class="prev" [disabled]="!customTourService.hasPrev(step)" (click)="tourPrev()">
                    <mat-icon>chevron_left</mat-icon>
                    {{ step.prevBtnTitle }}
                </button>
                } @if (step.showProgress && !isDirectSearchTour) {
                <div class="progress">
                    {{ customTourService.steps.indexOf(step) + 1 }} / {{ customTourService.steps.length }}
                </div>
                } @if (customTourService.hasNext(step) && !step.nextOnAnchorClick && !isDirectSearchTour) {
                <button class="next" (click)="tourNext()" mat-button>
                    {{ step.nextBtnTitle }}
                    <mat-icon iconPositionEnd>chevron_right</mat-icon>
                </button>
                } @if (!customTourService.hasNext(step) && !isDirectSearchTour) {
                <button mat-button (click)="tourEnd()">
                    {{ step.endBtnTitle }}
                </button>
                }
            </mat-card-actions>
        </mat-card>
    </ng-template>
</tour-step-template>

<div class="centered-tour-element" tourAnchor="centeredTourStep"></div>
